export default {"src":"/_next/static/media/pecan.248a6d9a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};